import axios from "axios";
import api from "@/api/api";
import moment from "moment";
// import _ from "lodash";

export const state = {
  listProject: [],
  existsProjectManagement: false,
  project: {},
  projectLifeTime: '',
  listKickOffBonus: [],
  listKickOffBonusDates: {},
  kickOffBonusInfo: null,
  newKickOff: null,
  listProjectMember: [],
  effortProjectDetail: [],
  employees: [],
  positions: [],
  customers: [],
  reviews: [],
  contract_management: [],
  haveReviews: false,
  // contract_management: [
  //   { date: '20/07/2022', document: 'zyxcba', timeSheet: 100 },
  //   { date: '20/07/2022', document: 'zyxcba', timeSheet: 100 },
  //   { date: '20/07/2022', document: 'zyxcba', timeSheet: 100 },
  // ],
  effortEmployeeProject: [],
  effortEmployeeProjectDetail: {},
  startEndDate: ''
};

// getters
export const getters = {
  listProject: state => state.listProject,
  existsProjectManagement: state => state.existsProjectManagement,
  project: state => state.project,
  projectLifeTime: state => state.projectLifeTime,
  listKickOffBonus: state => state.listKickOffBonus,
  listKickOffBonusDates: state => state.listKickOffBonusDates,
  kickOffBonusInfo: state => state.kickOffBonusInfo,
  newKickOff: state => state.newKickOff,
  listProjectMember: state => state.listProjectMember,
  effortProjectDetail: state => state.effortProjectDetail,
  employees: state => state.employees,
  positions: state => state.positions,
  customers: state => state.customers,
  reviews: state => state.reviews,
  haveReviews: state => state.haveReviews,
  contract_management: state => state.contract_management,
  effortEmployeeProject: state => state.effortEmployeeProject,
  effortEmployeeProjectDetail: state => state.effortEmployeeProjectDetail,
  startEndDate: state => state.startEndDate,
};

// mutations
export const mutations = {
  SET_LIST_PROJECT(state, payload) {
    state.listProject = payload;
  },
  SET_EXISTS_PROJECT_MANAGEMENT(state, payload) {
    state.existsProjectManagement = payload;
  },
  SET_LIST_KICK_OFF_BONUS(state, payload) {
    if (payload && payload.length > 0) {
      state.listKickOffBonus = payload;
      let listKickOffBonusDates = {};
      payload.map((value, index) => {
        if (value.date) {
          const dateC = moment(value.date, "YYYY-MM-DD hh:mm:ss");
          const date = moment(value.date, "YYYY-MM-DD hh:mm:ss").format('DD/MM/YYYY');
          const startDate = moment(state.project.start_date, "DD/MM/YYYY");
          const distantDateWithStart = dateC.diff(startDate, 'days');
          if (!listKickOffBonusDates[date]) {
            listKickOffBonusDates[date] = {};
            listKickOffBonusDates[date].distant = distantDateWithStart;
            listKickOffBonusDates[date].index = 0;
            listKickOffBonusDates[date].list = [];
          }
          listKickOffBonusDates[date].list.push(index);
        }
      });
      state.listKickOffBonusDates = listKickOffBonusDates;
    } else {
      state.listKickOffBonusDates = {};
      state.listKickOffBonus = [];
    }
  },
  SET_KICK_OFF_BONUS_INFO(state, payload) {
    state.kickOffBonusInfo = payload;
  },
  SET_PROJECT_DETAIL(state, payload) {
    state.project = payload;
    const startDate = moment(payload.start_date, "DD-MM-YYYY");
    const endDate = moment(payload.end_date, "DD-MM-YYYY");
    state.startEndDate = {startDate: startDate, endDate: endDate}
    state.projectLifeTime = endDate.diff(startDate, 'days');
  },
  SET_NEW_KICKOFF(state, payload) {
    state.newKickOff = payload;
  },
  SET_LIST_PROJECT_MEMBER(state, payload) {
    state.listProjectMember = payload;
  },
  GET_EFFORT(state, payload) {
    payload.map(item => {
      if (item.effort === null) {
        if (item.effort_default !== null) {
          item.effort = item.effort_default;
        } else {
          item.effort = 100;
        }
      }
      if (item.set_value === null) {
        item.set_value = 1;
      }
    })
    state.effortProjectDetail = payload;
  },
  SET_EMPLOYEES(state, payload) {
    state.employees = payload;
  },
  SET_POSITIONS(state, payload) {
    state.positions = payload;
  },
  SET_CUSTOMERS(state, payload) {
    state.customers = payload;
  },
  SET_REVIEWS(state, payload) {
    const { data, status } = payload;
    if (status === 200) {
      if (data) {
        let reviews = data;
        Object.keys(reviews).map((key) => {
          const startDate = moment(reviews[key].start_date).format("DD/MM/YYYY");
          const endDate = moment(reviews[key].end_date).format("DD/MM/YYYY");
          reviews[key].week_day = startDate + ' - ' + endDate;
          reviews[key].updated_at = moment(reviews[key].updated_at).format("DD/MM/YYYY");
        });
        const startDayCurrent = moment(new Date()).startOf("isoWeek").format("YYYY-MM-DD");
        if (!reviews[startDayCurrent]) {
          reviews[startDayCurrent] = {
            note: null,
            index: 1,
            project_id: payload.id,
            project_overview_items: {
              communication: 1,
              personnel: 1,
              progress: 1,
              quality: 1,
              schedule: 1,
              scope: 1,
              skill: 1,
              tech: 1,
            }
          };
        }
        state.reviews = reviews;
        state.haveReviews = true;
      } else {
        let reviews = {};
        const startDayCurrent = moment(new Date()).startOf("isoWeek").format("YYYY-MM-DD");
        reviews[startDayCurrent] = {
          note: null,
          index: 1,
          project_id: payload.id,
          project_overview_items: {
            communication: 1,
            personnel: 1,
            progress: 1,
            quality: 1,
            schedule: 1,
            scope: 1,
            skill: 1,
            tech: 1,
          }
        };
        state.reviews = reviews;
        state.haveReviews = false;
      }
    }
  },
  // SET_HAVE_REVIEWS(state, payload) {
  //   state.haveReviews = payload;
  // },
  SET_CONTRACT_HISTORY(state, payload) {
    const { data } = payload;
    state.contract_management = data;
  },
  SET_EFFORT_EMPLOYEE_PROJECT(state, payload) {
    state.effortEmployeeProject = payload;
  },
  SET_EFFORT_EMPLOYEE_PROJECT_DETAIL(state, payload) {
    if (payload) {
      state.effortEmployeeProjectDetail = payload;
    }
  },
  PUSH_TO_EFFORT_EMPLOYEE_PROJECT_DETAIL(state, payload) {
    if (payload) {
      state.effortEmployeeProjectDetail = { ...state.effortEmployeeProjectDetail, ...payload }
    }
  }
};

// actions
export const actions = {
  async getListProject({ commit }, params) {
    const response = await axios.get(`/api/projects?page=${params.page}&perpage=${params.perpage}`).then((res) => res.data);
    commit("SET_LIST_PROJECT", response);
  },
  async getExistsProjectManagement({ commit }) {
    const response = await axios.get(`/api/projects/check-exists-project`).then((res) => res.data);
    commit("SET_EXISTS_PROJECT_MANAGEMENT", response);
  },
  setListKickOffBonus({ commit }, data) {
    commit("SET_LIST_KICK_OFF_BONUS", data);
  },
  async getListKickOffBonus({ commit }, projectId) {
    const response = await axios.get(`/api/projects/${projectId}/kickoff-and-bonus`).then((res) => res.data);
    commit("SET_LIST_KICK_OFF_BONUS", response);
  },
  async getListProjectMember({ commit }, projectId) {
    const response = await axios.get(`/api/projects/${projectId}/kickoff-and-bonus/get-project-member`).then((res) => res.data);
    commit("SET_LIST_PROJECT_MEMBER", response);
  },
  async createKickOff({ commit }, params) {
    let projectId = params.get('project_id');
    const response = await axios
      .post(`/api/projects/${projectId}/kickoff-and-bonus`, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res.data)
      .catch((err) => err.response.data);
    commit("SET_NEW_KICKOFF", response);
  },
  async getEffort({ commit }, payload) {
    const { id, date } = payload;
    const response = await axios.get(api.PROJECT_MANAGEMENT.EFFORT + '/' + id + '/effort',
      { params: { date } });
    commit('GET_EFFORT', response.data);
  },
  async postEffort(_, payload) {
    const { id, formData } = payload;
    const response = await axios.post(api.PROJECT_MANAGEMENT.EFFORT + '/' + id + '/effort', formData);
    return response;
    // commit('GET_EFFORT', response.data);
  },
  async getProjectDetail({ commit }, id) {
    const response = await axios.get(api.PROJECT_MANAGEMENT.PROJECT_DETAIL + "/" + id);
    commit("SET_PROJECT_DETAIL", response.data)
  },
  async updateProjectDetail(_, { data, id }) {
    let url = api.PROJECT_MANAGEMENT.UPDATE_PROJECT_DETAIL.replace(":id", id);
    const response = await axios.post(url, data);
    return response;
  },
  async updateProjectEmployee(_, { data, id }) {
    let url = api.PROJECT_MANAGEMENT.UPDATE_PROJECT_EMPLOYEE.replace(":id", id);
    const response = await axios.post(url, data);
    return response;
  },
  async getEmployeeList({ commit }) {
    const response = await axios.get(api.LIST_EMPLOYEE);
    commit("SET_EMPLOYEES", response.data);
  },
  async updateEmployeeList({ commit }, data) {
    commit("SET_EMPLOYEES", data);
  },
  async getPositionList({ commit }) {
    const response = await axios.get(api.LIST_POSITION);
    commit("SET_POSITIONS", response.data);
  },
  // async setHaveReviews({ commit }, payload) {
  //   commit("SET_HAVE_REVIEWS", payload);
  // },
  async getReviews({ commit }, payload) {
    const { id } = payload;
    let url = api.PROJECT_MANAGEMENT.REVIEWS.replace(":id", id);
    let response = await axios.get(url.replace(":id", id));
    response.id = id;
    commit("SET_REVIEWS", response);
  },
  async getEmployeeTypeList({ commit }) {
    const response = await axios.get(api.LIST_EMPLOYEE_TYPE);
    commit("SET_POSITIONS", response.data);
  },
  async postReviews(_, payload) {
    const { id, formData } = payload;
    const response = await axios.post(api.PROJECT_MANAGEMENT.REVIEWS.replace(":id", id), formData);
    return response;
  },
  async getCustomerList({ commit }) {
    const response = await axios.get(api.LIST_CUSTOMER);
    commit("SET_CUSTOMERS", response.data);
  },
  async getEffortEmployeeProject({ commit }, id) {
    const response = await axios.get(api.PROJECT_MANAGEMENT.EFFORT_EMPLOYEE_PROJECT.replace(":id", id));
    commit("SET_EFFORT_EMPLOYEE_PROJECT", response.data);
  },
  async getEffortEmployeeProjectDetail({ commit }, payload) {
    const response = await axios.get(api.PROJECT_MANAGEMENT.EFFORT_EMPLOYEE_PROJECT_DETAIL.replace(":id", payload.id) + `?start_date=${payload.startDate}&end_date=${payload.endDate}`);
    if (payload.isPushData) {
      commit("PUSH_TO_EFFORT_EMPLOYEE_PROJECT_DETAIL", response.data);
    } else {
      commit("SET_EFFORT_EMPLOYEE_PROJECT_DETAIL", response.data);
    }
  },
  async postContractHistory(_, formData) {
    const response = await axios.post(api.PROJECT_MANAGEMENT.CREATE_CONTRACT_HISTORY, formData);
    return response;
  },
  async updateContractHistory(_, formData) {
    const response = await axios.post(api.PROJECT_MANAGEMENT.UPDATE_CONTRACT_HISTORY, formData);
    return response;
  },
  async getContractHistory({ commit }, payload) {
    const { id } = payload;
    let url = api.PROJECT_MANAGEMENT.CONTRACT_HISTORY.replace(":id", id);
    let response = await axios.get(url.replace(":id", id));
    response.id = id;
    commit("SET_CONTRACT_HISTORY", response);
  },
  async delContractHistory(_, id) {
    console.log(id)
    let response = await axios.delete(api.PROJECT_MANAGEMENT.CONTRACT_HISTORY.replace(":id", id));
    return response;
  }
};

// function loopDistant(arrDis, dis) {
//   if (!arrDis.includes(dis)) {
//     // console.log(arrDis, dis);
//     return parseInt(dis);
//   } else {
//     const newDis = _.cloneDeep(dis) + 1;
//     return loopDistant(arrDis, newDis);
//   }
// }
